import { FC, useMemo } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { ValkTalkFeedsClientProvider } from '../../../../connectors/ValkTalkFeedsClientProvider/ValkTalkFeedsClientProvider'
import { getDefaultSubRoutePathByNavigationRouteKey } from '../../../../helpers/routes'
import { ValkTalkPostsPage } from '../../../../pages'
import { ValkTalkRoutes } from '../../../../routes/helpers'
import { NavRoute } from '../../../../routes/routes'

interface ValkTalkRouteGroupProps {
    permittedUserRoutes: NavRoute[];
}

export const ValkTalkRouteGroup: FC<ValkTalkRouteGroupProps> = ({ permittedUserRoutes }) => {
    const defaultRoute = useMemo(() => getDefaultSubRoutePathByNavigationRouteKey('valkTalk', permittedUserRoutes), [permittedUserRoutes])

    return (
        <ValkTalkFeedsClientProvider>
            <Routes>
                <Route path={ValkTalkRoutes.posts()} element={<ValkTalkPostsPage />} />

                <Route path="/*" element={<Navigate to={defaultRoute} />} />
            </Routes>
        </ValkTalkFeedsClientProvider>
    )
}
